import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const RecoverPasswordView = angular
  .module('acme.view.recoverPassword', [uiRouter, 'ui.bootstrap', 'acme.view.recoverPassword.controllers'])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const recoverPassword = {
      name: 'recoverPassword',
      url: '/recoverPassword',
      abstract: true,
      views: {
        main: {
          controller: 'RecoverPasswordController',
          templateUrl: 'layouts/standard.tpl.html',
        },
      },
    };

    const recoverPasswordDefault = {
      name: 'recoverPassword.default',
      url: '',
      views: {
        'subview-main': {
          templateUrl: 'views/recoverPassword/recoverPassword.tpl.html',
        },
      },
      data: {
        pageClass: 'application-splash',
        pageTitle: 'Recover your password',
      },
    };

    $stateProvider.state(recoverPassword).state(recoverPasswordDefault);
  }).name;
